(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dealer-register"] && !Shopify.designMode) return;
  try {
    
// (function() {
//   var createCustomerForm = document.querySelector('#create_customer');
//   if (!createCustomerForm) return;

//   var allInputs = createCustomerForm.querySelectorAll('input,select,textarea');
//   var zipInput = document.getElementById('RegisterForm-ZIP');
//   if (zipInput) {
//     zipInput.addEventListener('input', function() {
//       this.value = this.value.replace(/\D/g, '');
//     });
//   }

//   var contactInput = document.getElementById('RegisterForm-ContactNumber');
//   if (contactInput) {
//     contactInput.addEventListener('input', function() {
//       var val = this.value.replace(/[^0-9]/g, '');
//       if (val.length >= 7) val = val.replace(/(\d{3})(\d{3})(\d+)/, '$1-$2-$3');
//       else if (val.length >= 4) val = val.replace(/(\d{3})(\d+)/, '$1-$2');
//       this.value = val;
//     });
//   }

//   function myValidation(ele) {
//     var errorLabel = ele.dataset.errorLabel;
//     var errorEl = ele.parentNode.querySelector('.form-field-error');
//     if (!errorEl) return;
//     if (ele.value === '') {
//       errorEl.innerText = errorLabel + ' is required';
//     } else {
//       errorEl.innerText = 'You have to enter a valid ' + errorLabel;
//     }
//   }

//   createCustomerForm.addEventListener('invalid', function(e) {
//     e.preventDefault();
//     myValidation(e.target);
//   }, true);

//   allInputs.forEach(function(ele) {
//     ele.addEventListener('input', function(e) {
//       var err = e.target.parentNode.querySelector('.form-field-error');
//       if (err) err.innerText = '';
//     });
//     ele.addEventListener('change', function(e) {
//       var err = e.target.parentNode.querySelector('.form-field-error');
//       if (err) err.innerText = '';
//     });
//   });

//   var billingInput = document.querySelector('#RegisterForm-BillingAddress');
//   if (billingInput) {
//     billingInput.addEventListener('blur', function() {
//       var val = this.value.trim();
//       var errorEl = this.parentNode.querySelector('.form-field-error');
//       if (val === '') {
//         errorEl.innerText = 'Billing Address is required';
//         this.setCustomValidity('This field is required');
//       } else if (val.length < 7 || !/\S\s+\S/.test(val)) {
//         errorEl.innerText = 'Invalid Billing Address';
//         this.setCustomValidity('Address must contain a space and be at least 7 characters');
//       } else {
//         errorEl.innerText = '';
//         this.setCustomValidity('');
//       }
//     });
//     billingInput.addEventListener('input', function() {
//       var errorEl = this.parentNode.querySelector('.form-field-error');
//       errorEl.innerText = '';
//       this.setCustomValidity('');
//     });
//   }

//   createCustomerForm.addEventListener('submit', function(e) {
//     e.preventDefault();
//     var formData = new URLSearchParams(new FormData(this));
//     var taxExempt = document.querySelector('select[name="customer_tax_exempt"]').value;
//     var signBtn = document.querySelector('#embed_5764d026-5de9-48f2-acff-f067477965f8');

//     document.querySelector('.success-modal').hidden = false;
//     document.querySelector('.embed_green_button').hidden = true;
//     document.querySelector('.success-modal_message').innerHTML = 'Your Application Is being Submitted. Please do not navigate away from this page.';

//     fetch('https://modway-custom-app-prod.azurewebsites.net/api/createcustomer', {
//       method: 'POST',
//       body: formData
//     })
//     .then(function(response) { return response.text(); })
//     .then(function(text) {
//       var data = JSON.parse(text);
//       if (data.sucess === false) {
//         document.querySelector('.success-modal').hidden = true;
//         document.querySelector('.warning-modal').hidden = false;
//         document.querySelector('.warning-modal_message').innerHTML = data.message;
//         document.querySelector('.embed_red_button').addEventListener('click', function(ev) {
//           ev.preventDefault();
//           document.querySelector('.warning-modal').hidden = true;
//         });
//       } else {
//         document.querySelector('.embed_green_button').hidden = false;
//         document.querySelector('.success-modal_message').innerHTML = data.message;
//         var links = {
//           'pay-state-sale-tax': 'https://secure.rightsignature.com/templates/6a52045e-15d8-4a72-b2d5-206a93b25c23/template-signer-link/a9fa5f19f0a9f278d133aa50fcd18fe1',
//           'register-ca': 'https://secure.rightsignature.com/templates/ab651b6b-455a-4451-aa22-14ce45df63e9/template-signer-link/120a7c9b5036300c972c0fbbbcc3b49f',
//           'register-nj': 'https://secure.rightsignature.com/templates/85fb9c4f-dfe9-4ea8-95fe-d77284472343/template-signer-link/d9c0c40c03fba922e10d4a080bd7a77d',
//           'register-ny': 'https://secure.rightsignature.com/templates/86a1cebd-1228-4bc6-b89c-1163e9816d05/template-signer-link/a061afa9c862e4083dc669959517216d',
//           'register-out-ca-nj-ny': 'https://secure.rightsignature.com/templates/eef2610b-d0a4-4dd2-979e-597c5de85af7/template-signer-link/5010c0f6a2485ecd29bb264097b32270'
//         };
//         if (links[taxExempt]) signBtn.href = links[taxExempt];
//       }
//     });
//   });
// })();

(function() {
  var createCustomerForm = document.querySelector('#create_customer');
  if (!createCustomerForm) return;

  var allInputs = createCustomerForm.querySelectorAll('input,select,textarea');
  var zipInput = document.getElementById('RegisterForm-ZIP');
  if (zipInput) {
    zipInput.addEventListener('input', function() {
      this.value = this.value.replace(/\D/g, '');
    });
  }

  var contactInput = document.getElementById('RegisterForm-ContactNumber');
  if (contactInput) {
    contactInput.addEventListener('input', function() {
      var val = this.value.replace(/[^0-9]/g, '');
      if (val.length >= 7) val = val.replace(/(\d{3})(\d{3})(\d+)/, '$1-$2-$3');
      else if (val.length >= 4) val = val.replace(/(\d{3})(\d+)/, '$1-$2');
      this.value = val;
    });
  }

  function myValidation(ele) {
    var errorLabel = ele.dataset.errorLabel;
    var errorEl = ele.parentNode.querySelector('.form-field-error');
    if (!errorEl) return;
    if (ele.value === '') {
      errorEl.innerText = errorLabel + ' is required';
    } else {
      errorEl.innerText = 'You have to enter a valid ' + errorLabel;
    }
  }

  createCustomerForm.addEventListener('invalid', function(e) {
    e.preventDefault();
    myValidation(e.target);
  }, true);

  allInputs.forEach(function(ele) {
    ele.addEventListener('input', function(e) {
      var err = e.target.parentNode.querySelector('.form-field-error');
      if (err) err.innerText = '';
    });
    ele.addEventListener('change', function(e) {
      var err = e.target.parentNode.querySelector('.form-field-error');
      if (err) err.innerText = '';
    });
  });

  var billingInput = document.querySelector('#RegisterForm-BillingAddress');
  if (billingInput) {
    billingInput.addEventListener('blur', function() {
      var val = this.value.trim();
      var errorEl = this.parentNode.querySelector('.form-field-error');
      if (val === '') {
        errorEl.innerText = 'Billing Address is required';
        this.setCustomValidity('This field is required');
      } else if (val.length < 7 || !/\S\s+\S/.test(val)) {
        errorEl.innerText = 'Invalid Billing Address';
        this.setCustomValidity('Address must contain a space and be at least 7 characters');
      } else {
        errorEl.innerText = '';
        this.setCustomValidity('');
      }
    });
    billingInput.addEventListener('input', function() {
      var errorEl = this.parentNode.querySelector('.form-field-error');
      errorEl.innerText = '';
      this.setCustomValidity('');
    });
  }

  createCustomerForm.addEventListener('submit', function(e) {
    e.preventDefault();
    // var formData = new URLSearchParams(new FormData(this));
    // var taxExempt = document.querySelector('select[name="customer_tax_exempt"]').value;
    
    grecaptcha.ready(function() {
      grecaptcha.execute('6LdJW9ctAAAAAIENqZJeOw7CiO5s7Fv6lJZ_8IbE', {
        action: 'CUSTOMER_CREATE'
      }).then(function(recaptchaToken) {

        var formData = new URLSearchParams(new FormData(createCustomerForm));
        formData.set('recaptcha_token', recaptchaToken);

    var taxExempt = document.querySelector('select[name="customer_tax_exempt"]').value;
    var signBtn = document.querySelector('#embed_5764d026-5de9-48f2-acff-f067477965f8');

    document.querySelector('.success-modal').hidden = false;
    document.querySelector('.embed_green_button').hidden = true;
    document.querySelector('.success-modal_message').innerHTML = 'Your Application Is being Submitted. Please do not navigate away from this page.';

    fetch('https://modway-custom-app-prod.azurewebsites.net/api/createcustomer', {
      method: 'POST',
      body: formData
    })
    .then(function(response) { return response.text(); })
    .then(function(text) {
      var data = JSON.parse(text);
      if (data.sucess === false) {
        document.querySelector('.success-modal').hidden = true;
        document.querySelector('.warning-modal').hidden = false;
        document.querySelector('.warning-modal_message').innerHTML = data.message;
        document.querySelector('.embed_red_button').addEventListener('click', function(ev) {
          ev.preventDefault();
          document.querySelector('.warning-modal').hidden = true;
        });
      } else {
        document.querySelector('.embed_green_button').hidden = false;
        document.querySelector('.success-modal_message').innerHTML = data.message;
        var links = {
          'pay-state-sale-tax': 'https://secure.rightsignature.com/templates/6a52045e-15d8-4a72-b2d5-206a93b25c23/template-signer-link/a9fa5f19f0a9f278d133aa50fcd18fe1',
          'register-ca': 'https://secure.rightsignature.com/templates/ab651b6b-455a-4451-aa22-14ce45df63e9/template-signer-link/120a7c9b5036300c972c0fbbbcc3b49f',
          'register-nj': 'https://secure.rightsignature.com/templates/85fb9c4f-dfe9-4ea8-95fe-d77284472343/template-signer-link/d9c0c40c03fba922e10d4a080bd7a77d',
          'register-ny': 'https://secure.rightsignature.com/templates/86a1cebd-1228-4bc6-b89c-1163e9816d05/template-signer-link/a061afa9c862e4083dc669959517216d',
          'register-out-ca-nj-ny': 'https://secure.rightsignature.com/templates/eef2610b-d0a4-4dd2-979e-597c5de85af7/template-signer-link/5010c0f6a2485ecd29bb264097b32270'
        };
        if (links[taxExempt]) signBtn.href = links[taxExempt];
      }
    });
          });
    });

  });
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
